import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import DownloadHolidayCom from './DownloadHolidayCom';
import ReactPaginate from "react-paginate";
import jwt_decode from 'jwt-decode';

import LeaveModal from './LeaveModal';
function EmpLeaveCom() {
    var currYearName = moment().format('Y');
    const get_oermission_data = useSelector((state) => state);

    let navigate = useNavigate();
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userInfo = jwt_decode(token.value)
    // console.log(userInfo.UserType,'userInfo.user_type========::')
    const userId = localStorage.getItem('userId');
    const [holidaylist, setHolidaylist] = useState([]);
    const [modalstatus, setModalstatus] = useState(false);
    const [leave_type, setLeave_type] = useState('0')
    const [fromdate, setFromdate] = useState()
    const [todate, setTodate] = useState()
    const [duration, setDuration] = useState()
    const [half, setHalf] = useState('0')
    const [reason, setReason] = useState();
    const [err, setErr] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [msg, setMsg] = useState('');
    const [errfromdatemsg, setErrfromdatemsg] = useState('');
    const [errtodatemsg, setErrtodatemsg] = useState('');
    const [durationmsg, setErrDurationmsg] = useState('');
    const [halfdurationmsg, setErrhalfdurationmsg] = useState('');
    const [leave, setLeave] = useState({});
    const [leavelist, setLeavelist] = useState([])
    const [id, setId] = useState('');
    const [modalcomment, setModalcomment] = useState(false);
    const [att_remark, setAtt_remark] = useState('')
    const [date_select, setDate_select] = useState('');
    const [openModelType, setOpenModelType] = useState('');

    const pagination = useRef();
    const [totalitem, setTotalitem] = useState('');
    const [perPage, setPerpage] = useState(10);
    const [pages, setPages] = useState(1);

    const setPage = ({ selected }) => {
        getLeaveList()
        setPages(selected + 1)
    }

    const HandleLeaveModal = () => {
        setModalstatus(true)
        setOpenModelType('add')
    }
    const handleClose = () => {
        setModalcomment(false)
        setAtt_remark('')
        setModalstatus(false)
        setErr('')
        setMsg('')
        setMsg('')
        setReason('')
        setLeave_type('0')
        setId('')
        setFromdate('')
        setTodate('')
        setDuration('')
        setHalf('0')
        setReason('')
    }



    const [error, setError] = useState(null);
    const controller = new AbortController();
    const signal = controller.signal; // The signal that we will pass to the fetch request

    useEffect(() => {
        const getholidayList = async (pagenumber) => {
            try {
                const response = await fetch(SERVER_URL + `api/holiday/office-holiday-list`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        signal: signal
                    })
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                if (result.status == true) {
                    setHolidaylist(result.result)
                }

            } catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch request was aborted');
                } else {
                    setError(err.message || 'An error occurred');
                }
            }
        }
        getholidayList()
        return () => {
            controller.abort(); // This will cancel the fetch request when the component unmounts
        };
    }, [])
    useEffect(() => {
        const getEmpLeave = async () => {
            try {
                const response = await fetch(SERVER_URL + `api/attendance/leave-balance-list`,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        body: JSON.stringify({
                            EmpID: userId
                        }),
                        signal: signal
                    })
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                if (result.status == true) {
                    setLeave(result.data)
                }
                // .then(res => res.json())
                // .then(data => {
                //     //console.log(data.data,'user leave balance======::')
                //     if (data.status == true) {
                //         setLeave(data.data)
                //     }
                // })
            } catch (err) {
                if (err.name === 'AbortError') {
                    console.log('Fetch request was aborted');
                } else {
                    setError(err.message || 'An error occurred');
                }
            }
        }
        getEmpLeave()
        return () => {
            controller.abort(); // This will cancel the fetch request when the component unmounts
        };
    }, [])

    // const handleSubmit = () => {
    //     const isEmpty = (value) => value === '' || value === null || value === undefined;
    //     console.log(leave_type,'leave_type')
    //     console.log(fromdate,'fromdate')
    //     console.log(todate,'todate')
    //     console.log(duration,'duration')
    //     console.log(half,'half')
    //     // Reset error states
    //     setErr('green');
    //     setErrmsg('');
    //     setErrfromdatemsg('');
    //     setErrtodatemsg('');
    //     setErrDurationmsg('');
    //     setErrhalfdurationmsg('');

    //     // Validation checks
    //     if (isEmpty(leave_type) || leave_type === '0') {
    //         setErr('red');
    //         setErrmsg('Leave type is required');
    //         return false;
    //     }

    //     if (isEmpty(fromdate)) {
    //         setErr('red');
    //         setErrfromdatemsg('From date is required');
    //         return false;
    //     }

    //     if (isEmpty(todate)) {
    //         setErr('red');
    //         setErrtodatemsg('To date is required');
    //         return false;
    //     }

    //     if (isEmpty(duration)) {
    //         setErr('red');
    //         setErrDurationmsg('Duration is required');
    //         return false;
    //     }
    //     if (isEmpty(half)) {

    //         return false;
    //     }


    //     if (id) {
    //         editLeave();
    //     } else {
    //         addLeave();
    //     }
    // };
    // const handleSubmit = () => {
    //     setErr('green')
    //     setErrmsg('')
    //     setErrfromdatemsg('')
    //     setErrtodatemsg('')
    //     if (leave_type === '' || leave_type === null || leave_type === 'undefined' || leave_type === '0') {
    //         setErr('red')
    //         setErrmsg(' Is Required')
    //         return false
    //     }else if (fromdate === '' || fromdate === null || fromdate === 'undefined') {
    //         setErr('red')
    //         setErrfromdatemsg(' Is Required')
    //     }else if (todate === '' || todate === null || todate === 'undefined') {
    //         setErr('red')
    //         setErrtodatemsg(' Is Required')
    //     }else if (duration === '' || duration === null || duration === 'undefined') {
    //         setErr('red')
    //         setErrtodatemsg(' Is Required')
    //     }else if ((duration === 2 && duration === '') || (duration === 2 && duration === null) || (duration === 2 && duration === 'undefined')) {
    //         setErr('red')
    //         setErrtodatemsg(' Is Required')
    //     } else {
    //         if (id != '') {
    //             editLeave()
    //         } else {
    //             addLeave()
    //         }
    //     }
    // }
    // const editLeave = () => {
    //     const response = fetch(SERVER_URL + `api/leave/leave-update`,
    //         {
    //             method: 'PUT',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //             body: JSON.stringify({
    //                 leaveId: id,
    //                 formDate: fromdate,
    //                 toDate: todate,
    //                 requestType: 3,
    //                 leaveType: leave_type,
    //                 leaveDuration: duration,
    //                 description: reason,
    //                 requestedBy: userId

    //             }),
    //         }).then(res => res.json())
    //         .then(data => {
    //             if (data.status == true) {
    //                 setMsg('Leave successfully updated')
    //                 setErr('green')
    //                 getLeaveList()
    //                 setTimeout(function () {
    //                     handleClose()
    //                 }, 1000);
    //             }
    //         });
    // }
    // const addLeave = () => {
    //     const userId = localStorage.getItem('userId');
    //     const response = fetch(SERVER_URL + `api/leave/apply-leave`,
    //         {
    //             method: 'post',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //             body: JSON.stringify({
    //                 EmpID: userId,
    //                 requestType: 3,
    //                 formDate: fromdate,
    //                 toDate: todate,
    //                 leaveType: leave_type,
    //                 leaveDuration: duration,
    //                 durationDay: 1,
    //                 description: reason
    //             }),
    //         }).then(res => res.json())
    //         .then(data => {
    //             if (data.status == true) {
    //                 setMsg('Leave successfully added')
    //                 setErr('green')
    //                 getLeaveList(currYearName)
    //                 setTimeout(function () {
    //                     handleClose()
    //                 }, 1000);
    //             }
    //         })
    // }
    useEffect(() => {
        getLeaveList(currYearName)
        getCountLeave(currYearName)
        // alert(currYearName)
    }, [pages])

    const [availedEl, setAvailedEl] = useState(0);
    const [availedCl, setAvailedCl] = useState(0);
    const [availedSl, setAvailedSl] = useState(0);
    const [availedLwp, setAvailedLwp] = useState(0);
    function getCountLeave(currYearName) {
        fetch(SERVER_URL + `api/leave/leave-emp-count`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                empID: userId,
                currYearName: currYearName
            }),
        }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    data.data.map((item) => {
                        if (item.leave_type == 1) {
                            setAvailedEl(item.leave_count)
                        }
                        if (item.leave_type == 2) {
                            setAvailedCl(item.leave_count)
                        }
                        if (item.leave_type == 3) {
                            setAvailedSl(item.leave_count)
                        }
                        if (item.leave_type == 4) {
                            setAvailedLwp(item.leave_count)
                        }
                    })
                }
            })
    }
    function getLeaveList() {
        fetch(SERVER_URL + `api/leave/leave-history?page=${pages}&&empID=${userId}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            // body: JSON.stringify({
            //     empID: userId,
            //     currYearName: currYearName,
            //     pages:pages
            // }),
        }).then(res => res.json())
            .then(data => {
                setLeavelist(data.data)
                setTotalitem(data.leaveTotal)
            })
    }

    const dateConverter2 = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result
    }
    const dateConverter = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result > 1 ? result + ' Days' : result + 'Day'
    }
    const leave_type_arr = ["", "Earned Leave", "Casual Leave", "Sick Leave", "Leave Without Pay", "Vacation Holiday"];
    const HandleEdit = (id) => {
        setId(id)
        setOpenModelType('edit')
        setModalstatus(true)
    }
    const HandleDelete = (id) => {
        fetch(SERVER_URL + `api/leave/leave-delete`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id,
                    statusValue: '1',
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getLeaveList(currYearName)
                }
            });
    }
    function getTotalLeave(el, cl, sl) {
        var total = 'N/A';
        if ((el !== '' || el != null || el != undefined) && (cl !== '' || cl != null || cl != undefined) && (sl !== '' || sl != null || sl != undefined)) {
            var total = el + cl + sl;
            total = total == '' ? 'N/A' : total;
        }
        return total == 'NaN' ? 'N/A' : total;
    }
    const handleMSG = (id) => {
        const response = fetch(SERVER_URL + `api/leave/get-leave-remark`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setAtt_remark(data.data.remark)
                }
            })
        setModalcomment(true)



    }
    return (
        <div className='container-fluid'>
            <Modal show={modalcomment} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross fw-bold"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div className="dash_white_box_ttl text-left mb10" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-2">
                        <textarea value={att_remark} className="form-control" readOnly placeholder="" >{att_remark}</textarea>
                    </div>
                </div>
            </Modal>
            <LeaveModal modal_type={openModelType} modalstatus={modalstatus} setModalstatus={setModalstatus} handleClose={handleClose} getLeaveList={getLeaveList} leave_id={id} />
            {/* <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
                    <div className="decorative-shape shape-1"></div>
                    <div className="decorative-shape shape-2"></div>
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross fw-bold"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{id != '' ? 'Edit Apply Leave' : ''}</div>
                    <div className="mb-2">
                        <label className="col-form-label">Leave Type :<span style={{ color: err }}>{errmsg}</span></label>
                        <select value={leave_type} onChange={(e) => { setLeave_type(e.target.value) }} className="form-select">
                            <option value=''>Select Type</option>
                            {
                                get_oermission_data?.login_Permission?.user_data?.time_zone == 5 &&
                                <option value='1'>Earned Leave</option>
                            }
                            {
                                get_oermission_data?.login_Permission?.user_data?.time_zone == 5 &&
                                <option value='2'>Casual Leave</option>
                            }
                            {
                                get_oermission_data?.login_Permission?.user_data?.time_zone == 5 &&
                                <option value='3'>Sick Leave</option>
                            }
                            {
                                get_oermission_data?.login_Permission?.user_data?.time_zone == 5 &&
                                <option value='4'>Leave Without Pay</option>
                            }
                            {
                                get_oermission_data?.login_Permission?.user_data?.time_zone != 5 &&
                                <option value='5'>Vacation Holiday</option>
                            }
                        </select>
                    </div>
                    <div className="mb-2">
                        <div className="row">
                            <div className="col-md-6 pr07">
                                <label className="col-form-label">From Date :<span style={{ color: err }}>{errfromdatemsg}</span></label>
                          

                                <DatePicker
                                    placeholderText='YYYY-MM-DD'
                                    value={fromdate}
                                    id="datetime-local"
                                    date={fromdate}
                                    onChange={HandleFromDate}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className="col-md-6 pl07">
                                <label className="col-form-label">To Date :<span style={{ color: err }}>{errtodatemsg}</span></label>
                              

                                <DatePicker
                                    placeholderText='YYYY-MM-DD'
                                    value={todate}
                                    id="datetime-local"
                                    date={todate}
                                    onChange={HandleToDate}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                        </div>
                        <label className="totalnumber " >Total Number of days - <span style={{ color: "red" }}>{date_select}</span></label>
                    </div>
                    <div className="mb-2">
                        <label className="col-form-label">Duration :<span style={{ color: err }}>{durationmsg}</span></label>
                        <select value={duration} onChange={(e) => { setDuration(e.target.value) }} className="form-select mb08" id="duration">
                        <option value={``}>Select Duration</option>
                            <option value="1">Full Day</option>
                            <option value="2">Half Day</option>
                        </select>
                    </div>
                    <div className="hide_halfday" style={{ display: duration === 2 ? 'block' : 'none' }}>
                        <div className="mb-2" >
                        <label className="col-form-label">Half Duration :<span style={{ color: err }}>{halfdurationmsg}</span></label>
                            <select value={half} onChange={(e) => setHalf(e.target.value)} id="halfday" className="form-select">
                                <option value={``}>Select Half Day</option>
                                <option value='1'>First Half</option>
                                <option value='2'>Second Half</option>
                            </select>
                        </div>
                    </div>
                    <div className="mb-2">
                        <label className="col-form-label">Reason</label>
                        <textarea value={reason} className="form-control" onChange={(e) => { setReason(e.target.value) }} cols="2" id="reason">{reason}</textarea>
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Leave Balance</label>
                        <ul className="l_balnce">
                            <li className="lwp">CFL - 10</li>
                            <li className="cl">EL - 15</li>
                            <li className="sl">CL - 2</li>
                            <li className="sl">SL - 2</li>
                            <li className="el">TL - 20</li>
                            <li className="py">LWP - 0</li>
                        </ul>
                    </div>
                    <div className="modalfooter">
                        <span className="text-right mb10 d-block" style={{ color: err }}>{msg}</span>
                        <div className="row">
                            <div className="col-md-6 pr07"> 
                                <button type="button" disabled={validdate} onClick={handleSubmit} className="btn_5 w-100">Submit</button>
                            </div>
                            <div className="col-md-6 pl07">
                                <button type="button" onClick={handleClose} className="btn_6 w-100" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> */}
            {userInfo.UserType === 1 ? <div className="dash_ttl">
                <button className="btn_5 mr10 float-end" onClick={HandleLeaveModal}>Apply Leave</button>
                Leave
            </div> : ''}
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Leave
                    </li>
                </ul>
            </div>
            <div className="row mb30">
                <div className="col-md-8">
                    {userInfo.UserType === 1 ? <div className="dash_white_box2 mb20 p20">
                        <div className="dash_white_box_ttl">Leave Balance</div>
                        <ul className="leavebalance_wrp">

                            <li className="leavebalance_blk lwp">
                                <div className="leavebalance_num_blk leave_lwp">
                                    <div className="leavebalance">{leave.carry_forward ? leave.carry_forward : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Carry Forward</div>
                            </li>

                            <li className="leavebalance_blk cl">
                                <div className="leavebalance_num_blk leave_cl">
                                    <div className="leavebalance">{leave.el_leave ? (leave.el_leave) : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Earned Leave - EL</div>
                                <div className="leavebalance_hover">
                                    <div className="leavebalance_ttl">Balance Leave</div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Opening</div>
                                        <div>{leave.el_leave ? leave.el_leave - 1.25 : 'N/A'}</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Accrued</div>
                                        <div>1.25</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Availed </div>
                                        <div>0</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Total EL</div>
                                        <div>{'N/A'}</div>
                                    </div>
                                </div>
                            </li>

                            <li className="leavebalance_blk sl">
                                <div className="leavebalance_num_blk leave_sl">
                                    <div className="leavebalance">{leave?.cl_leave ? leave.cl_leave : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Casual Leave - CL </div>
                                <div className="leavebalance_hover">
                                    <div className="leavebalance_ttl">Balance Leave</div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Opening</div>
                                        <div>{leave.cl_leave ? leave.cl_leave : 'N/A'}</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Accrued</div>
                                        <div>0.5</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Availed</div>
                                        <div>{availedCl} </div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Total CL</div>
                                        <div>{leave?.cl_leave ? leave.cl_leave : 'N/A'}</div>
                                    </div>
                                </div>
                            </li>

                            <li className="leavebalance_blk sl">
                                <div className="leavebalance_num_blk leave_sl">
                                    <div className="leavebalance">{leave?.sl_leave ? leave.sl_leave : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Sick Leave - SL</div>
                                <div className="leavebalance_hover">
                                    <div className="leavebalance_ttl">Balance Leave</div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Opening</div>
                                        <div>{leave.sl_leave ? leave.sl_leave - 0.5 : 'N/A'}</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Accrued</div>
                                        <div>0.5</div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Availed </div>
                                        <div>{availedSl} </div>
                                    </div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Total SL</div>
                                        <div>{leave?.sl_leave ? leave.sl_leave : 'N/A'}</div>
                                    </div>
                                </div>
                            </li>

                            <li className="leavebalance_blk el">
                                <div className="leavebalance_num_blk leave_el">
                                    <div className="leavebalance">
                                        {leave ? (leave?.el_leave + leave?.cl_leave + leave?.sl_leave) : 'N/A'}
                                        {/* {getTotalLeave(leave?.el_credit ? leave.el_credit : '', leave?.cl_credit ? leave.cl_credit : '', leave?.sl_credit ? leave.sl_credit : '') - (availedEl ? availedEl : 0) - (availedCl ? availedCl : 0) - (availedSl ? availedSl : 0)} */}
                                    </div>
                                </div>
                                <div className="leavebalance_ttl">Total Leave</div>
                            </li>

                            <li className="leavebalance_blk py">
                                <div className="leavebalance_num_blk leave_py">
                                    <div className="leavebalance">N/A</div>
                                </div>
                                <div className="leavebalance_ttl">Leave without pay</div>
                                <div className="leavebalance_hover">
                                    <div className="leavebalance_ttl">Balance Leave</div>
                                    <div className="leavebalance_ttl">
                                        <div><span></span>Availed </div>
                                        <div>{availedLwp}</div>
                                    </div>
                                </div>
                            </li>

                        </ul>
                    </div> : ''}
                    <div className="contentwrp content_wrp">
                        <div className="tab_wrapper tab_wrapper1">
                            <div className="dash_white_box_ttl">Leave History</div>
                            <table className="table_style_1">
                                <thead>
                                    <tr>
                                        <th>Leave Type</th>
                                        <th>Date</th>
                                        <th>Count</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        leavelist?.map((item, ind) => {
                                            return <tr key={ind + 1}>
                                                <td>{item.request_type == 2 && <span className="avatar_icon">Rg</span>}
                                                    {item.request_type != 2 && <span className="avatar_icon">{leave_type_arr[item?.leave_type] ? leave_type_arr[item?.leave_type].match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>}

                                                </td>
                                                <td>

                                                    {item.request_type != 2 && <span>
                                                        {moment(item.from_date).format('DD MMM, yyyy')} - {moment(item.to_date).format('DD MMM, yyyy')}
                                                    </span>
                                                    }
                                                    {item.request_type == 2 && <span>
                                                        {moment(item.regularize_date).format('DD MMM, yyyy')} ({moment(item.start_time, ["HH:mm"]).format("hh:mm A")}-{moment(item.end_time, ["HH:mm"]).format("hh:mm A")})
                                                    </span>
                                                    }
                                                </td>
                                                <td>
                                                    {item.request_type == 2 ? dateConverter(new Date(item?.to_date), new Date(item?.from_date)) : ''}
                                                    {item.request_type == 3 && item.duration_type === 2 ? '0.5 Half' : ''}
                                                    {item.request_type == 3 && item.duration_type === 1 ? dateConverter(new Date(item?.to_date), new Date(item?.from_date)) : ''}</td>
                                                <td>{item?.user_remarks}</td>
                                                <td>
                                                    {(
                                                        function () {
                                                            if (item.status == 0) {
                                                                return <span className="badge bg-warning">Pending</span>
                                                            }
                                                            if (item.status == 1) {
                                                                // return <span className='badge bg-primary'>Approved</span>
                                                                return <span className='badge bg-success'>Approved</span>
                                                            }
                                                            if (item.status == 3) {
                                                                return <span className='badge bg-danger'>Reject</span>
                                                            }
                                                        }()
                                                    )}


                                                </td>
                                                <td >
                                                    {(
                                                        function () {
                                                            if (item.request_type == 2 && item.status == 0) {

                                                            }
                                                            if (item.request_type != 2 && item.status == 0) {
                                                                return <>
                                                                    {/* <button onClick={(e) => { HandleEdit(item?.id) }} className="btn_7 mr03">Edit</button> */}
                                                                    <button className="btn_8" onClick={(e) => { HandleDelete(item?.id) }}>Delete</button>

                                                                </>
                                                            }
                                                            // if (item.status == 1) {
                                                            //     return <span className="btn_5" onClick={(e) => { handleMSG(item.id) }}>Reason</span>
                                                            // }
                                                            if (item.status == 3) {
                                                                return <span className="btn_5" onClick={(e) => { handleMSG(item.id) }}>Reason</span>
                                                            }

                                                        }()
                                                    )}
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                                <tfoot>


                                    <tr><td colSpan="8" >
                                        <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                                        <ReactPaginate
                                            ref={pagination}
                                            pageCount={Math.ceil(totalitem / perPage)}
                                            pageRangeDisplayed={4}
                                            marginPagesDisplayed={1}
                                            onPageChange={setPage}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            pageLinkClassName="page-link"
                                            breakLinkClassName="page-link"
                                            nextLinkClassName="page-link"
                                            previousLinkClassName="page-link"
                                            pageClassName="page-item"
                                            breakClassName="page-item"
                                            nextClassName="page-item"
                                            previousClassName="page-item"
                                            previousLabel={<>&laquo;</>}
                                            nextLabel={<>&raquo;</>}
                                        />
                                    </td></tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl"><DownloadHolidayCom /> List of Holidays </div>
                        <ul className="holiday_list_wrp">
                            {
                                holidaylist?.map((item, ind) => {
                                    return <li key={ind + 1} className="holiday_list_blk">
                                        <div className="holiday_list">
                                            <img src="assets/images/holidays.png" />
                                            <span>{moment(item.holiday_date).format('DD MMM, yyyy')}
                                            </span>
                                            <span>{moment(item.holiday_date).format('dddd')}</span>
                                        </div>
                                        <div className="holiday_list">
                                            <span>{item.level}</span>
                                            <span>{item?.holiday_type == 1 ? 'Restricted Holiday' : item?.holiday_type == 3 ? 'National Holiday' : item?.holiday_type == 2 ? 'Gazetted Holiday' : item?.holiday_type}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                        <p className="fs12">There are three National Holidays in India, 26th January, 15th August and 2nd October and there is a Major festivals like Holi and Diwali</p>
                    </div>
                </div>

            </div>



        </div >
    )
}

export default EmpLeaveCom
